export default __webpack_public_path__ + "static/media/img7.7af88cd4.png";